<template>
    <div
        v-if="outside || componentNav || event"
        class="button-main"
        :class="`button-main__${color}`"
        :color="color"
        :widthStatic="widthStatic"
        :style="{ width: buttonResult }"
    >
        <a
            v-if="outside"
            target="_blank"
            rel="noopener noreferrer"
            :href="link"
            :text="text"
        >
            <span class="button">
                <span class="button-text">
                    {{ text }}
                    <span />
                </span>
                <SvgLoader v-if="svg" :name="name" :style="svgStyle" />
            </span>
        </a>
        <a v-else-if="event" :text="text" @click="clickMethod">
            <span class="button">
                <span class="button-text">
                    {{ text }}
                    <span />
                </span>
                <SvgLoader v-if="svg" :name="name" :style="svgStyle" />
            </span>
        </a>
        <router-link v-else :to="{ name: link }" :text="text">
            <span class="button">
                <span class="button-text">
                    {{ text }}
                    <span />
                </span>

                <SvgLoader v-if="svg" :name="name" :style="svgStyle" />
            </span>
        </router-link>
    </div>

    <div
        v-else-if="samePage"
        v-scroll-to="`${target}`"
        class="button-main"
        :class="`button-main__${color}`"
        :href="target"
        :style="{ width: btnWidth }"
        :color="color"
        target="_blank"
        :text="text"
    >
        <a>
            <slot> {{ text }}</slot>
        </a>
    </div>

    <button
        v-else-if="submitButton"
        class="button-main"
        :class="`button-main__${color}`"
        type="submit"
    >
        <slot></slot>
    </button>
</template>

<script>
// import SvgIcon from './SvgLoader.vue';

export default {
    name: 'Button',

    props: {
        color: {
            default: 'orange',
            validator: function(value) {
                return (
                    [
                        'veryDarkBlue',
                        'transparent',
                        'orange',
                        'pastelGreen',
                    ].indexOf(value) !== -1
                );
            },
        },
        name: {
            type: String,
            default: '',
        },
        svgStyle: {
            type: String,
            default: null,
        },
        to: {
            type: String,
            default: '',
        },
        event: {
            type: Boolean,
            default: false,
        },

        btnWidth: {
            default: '',
            type: String,
        },
        samePage: {
            type: Boolean,
            default: false,
        },
        svg: {
            type: Boolean,
            default: false,
        },
        widthStatic: {
            default: '',
            type: String,
        },
        target: {
            default: '',
            type: String,
        },
        text: {
            type: String,
            default: '',
        },
        link: {
            type: String,
            default: null,
        },

        outside: {
            type: Boolean,
            default: false,
        },
        componentNav: {
            type: Boolean,
            default: false,
        },
        submitButton: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data: function() {
        return {
            style: { width: this.btnWidth },
            windowWidth: window.innerWidth,
        };
    },
    computed: {
        isMobile() {
            return this.windowWidth <= 414;
        },
        isTablet() {
            return this.windowWidth <= 768 && this.windowWidth > 414;
        },
        isHiDPI() {
            return this.windowWidth <= 1440 && this.windowWidth > 768;
        },
        isDesktop() {
            return this.windowWidth <= 1920 && this.windowWidth > 1440;
        },

        buttonResult() {
            let buttonWidth;

            if (this.widthStatic != '') {
                buttonWidth = this.widthStatic;
            } else if (this.isMobile) {
                buttonWidth = '160px';
            } else if (this.isTablet) {
                buttonWidth = '170px';
            } else if (this.isHiDPI) {
                buttonWidth = '231px';
            } else {
                buttonWidth = '231px';
            }

            this.setBtnWdth(buttonWidth);
            return buttonWidth;
        },
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
        });

        this.btnWidth = this.buttonResult;
    },
    methods: {
        clickMethod() {
            this.$emit('eventMethod');
        },
        setBtnWdth(buttonWidth) {
            this.btnWidth = buttonWidth;
        },
    },
};
</script>

<style scoped lang="scss">
.button-text {
    line-height: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    height: 100%;
    width: 100%;
    display: flex;
}

.icon {
    height: 19px;
    width: 19px;
    display: block;
    float: left;
    border: none;
    margin-right: 10px;
}
.button-main {
    cursor: pointer;
    background-color: $orange-button-color;
    font-size: 14px;
    text-align: center;
    height: 48px;
    letter-spacing: 1px;
    font-family: $istok-font;
    font-weight: 700;
    color: #fff;
    white-space: nowrap;
    display: flex;
    transition: all ease 0.3s;

    &__veryDarkBlue {
        background-color: $very-dark-button-color;
        border: $button-border $very-dark-button-color;
        border-radius: $button-border-radius;
    }

    &__orange {
        background-color: $orange-button-color;
        border: $button-border $orange-button-color;
        border-radius: $button-border-radius;
    }

    &__transparent {
        background-color: $transparent-button-color;
        border: $button-border $white-main;
        border-radius: $button-border-radius;
    }

    &__pastelGreen {
        background-color: $green-button-color;
        border: $button-border $green-button-color;
        border-radius: $button-border-radius;
        color: $blue-main;
    }

    .button {
        display: inline-flex;
    }
    a {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    &:hover {
        transition: all ease 0.3s;
        transform: translateY(-2px);
    }
    &:active {
        transition: all ease 0.3s;
        transform: translateY(-3px);
    }
}
</style>
